import { Grid, Button } from "@material-ui/core";
import React, { useState } from "react";
import DashboardItem from "../DashboardItem/DashboardItem";
import { PrimaryText } from "components/Common/PrimaryText";
import { View } from "react-native-web";
import { useForeverX } from "context/ForeverXContext";
import { recomputeCompanyCounts } from "services/retention-service";
import { SubscriptionStats } from "components/SubscriptionStats";

export const DashboardSection = () => {
	const { companyData } = useForeverX();
	const [recomputeLoading, setRecomputeLoading] = useState(false);

	const handleRecount = async () => {
		if (
			!window.confirm(
				"Recalculate company counts from scratch? This may take a moment.",
			)
		) {
			return;
		}

		setRecomputeLoading(true);
		try {
			const result = await recomputeCompanyCounts();
			const before = result?.before ?? "N/A";
			const after = result?.after ?? "N/A";
			const difference = result?.difference ?? "N/A";
			alert(
				`Recount complete.\nBefore: ${before}\nAfter: ${after}\nDifference: ${difference}`,
			);
		} catch (error) {
			if (error.code?.endsWith("permission-denied")) {
				alert("Permission denied. Only admins can recalculate counts.");
			} else {
				alert(
					"Error recalculating counts: " + (error.message || "Unknown error"),
				);
			}
		} finally {
			setRecomputeLoading(false);
		}
	};

	return (
		<View style={{ flex: 1, width: "100%" }}>
			<Grid container className="dashboardSection">
				{/* -----------------------  Dashboard first row ends  ----------------------- */}
				<Grid
					item
					container
					xs={12}
					className="dashboardRow"
					style={{ flexWrap: "wrap" }}
				>
					<DashboardItem>
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "flex-start",
							}}
						>
							<div>
								<PrimaryText
									fontSize={20}
									fontWeight={700}
									style={{ marginVertical: 12 }}
								>
									Total Users
								</PrimaryText>
								<PrimaryText fontSize={36} fontWeight={800}>
									{companyData?.usersCount ?? "N/A"}
								</PrimaryText>
							</div>
							<Button
								size="small"
								onClick={handleRecount}
								disabled={recomputeLoading}
								style={{ marginTop: 12, textTransform: "none", fontSize: 12 }}
							>
								{recomputeLoading ? "Recalculating..." : "Recalculate"}
							</Button>
						</div>
					</DashboardItem>

					<DashboardItem>
						<PrimaryText
							fontSize={20}
							fontWeight={700}
							style={{ marginVertical: 12 }}
						>
							Current Users
						</PrimaryText>
						<PrimaryText fontSize={36} fontWeight={800}>
							{companyData?.currentUsersCount ?? "N/A"}
						</PrimaryText>
					</DashboardItem>

					<DashboardItem>
						<PrimaryText
							fontSize={20}
							fontWeight={700}
							style={{ marginVertical: 12 }}
						>
							Active (30d)
						</PrimaryText>
						<PrimaryText fontSize={36} fontWeight={800}>
							{companyData?.activeUserCount ?? "N/A"}
						</PrimaryText>
					</DashboardItem>

					<DashboardItem>
						<PrimaryText
							fontSize={20}
							fontWeight={700}
							style={{ marginVertical: 12 }}
						>
							Active (24h)
						</PrimaryText>
						<PrimaryText fontSize={36} fontWeight={800}>
							{companyData?.activeUsersLastDay ?? "N/A"}
						</PrimaryText>
					</DashboardItem>
				</Grid>
				<PrimaryText fontSize={12} fontWeight={400}>
					User counts are recomputed hourly. Recalculate recomputes them immediately.
				</PrimaryText>
				{/* -----------------------  Dashboard first row ends  ----------------------- */}

				{/* -----------------------  Dashboard second row starts ----------------------- */}
				<Grid
					item
					container
					xs={12}
					className="dashboardRow"
					style={{ flexWrap: "wrap" }}
				>
					<DashboardItem>
						<PrimaryText
							fontSize={20}
							fontWeight={700}
							style={{ marginVertical: 12 }}
						>
							Messages Sent
						</PrimaryText>
						<PrimaryText fontSize={36} fontWeight={800}>
							{companyData?.messageCount ?? "N/A"}
						</PrimaryText>
					</DashboardItem>

					<DashboardItem>
						<PrimaryText
							fontSize={20}
							fontWeight={700}
							style={{ marginVertical: 12 }}
						>
							Reports submitted
						</PrimaryText>
						<PrimaryText fontSize={36} fontWeight={800}>
							{companyData?.reportsCount ?? "N/A"}
						</PrimaryText>
					</DashboardItem>

					<DashboardItem>
						<PrimaryText
							fontSize={20}
							fontWeight={700}
							style={{ marginVertical: 12 }}
						>
							Swipes
						</PrimaryText>
						<PrimaryText fontSize={36} fontWeight={800}>
							{companyData?.swipeCount ?? "N/A"}
						</PrimaryText>
					</DashboardItem>
				</Grid>

				{/* -----------------------  Dashboard second row ends ----------------------- */}

				{/* -----------------------  Dashboard third row  starts ----------------------- */}
				<Grid
					item
					container
					xs={12}
					className="dashboardRow lastRow"
					style={{ flexWrap: "wrap" }}
				>
					<DashboardItem>
						<PrimaryText
							fontSize={20}
							fontWeight={700}
							style={{ marginVertical: 12 }}
						>
							Matches Made
						</PrimaryText>
						<PrimaryText fontSize={36} fontWeight={800}>
							{companyData?.matchesCount ?? "N/A"}
						</PrimaryText>
					</DashboardItem>

					<DashboardItem
						item
						xs={12}
						sm={6}
						className="itemPadding registeredUsersItem"
					>
						<PrimaryText
							fontSize={20}
							fontWeight={700}
							style={{ marginVertical: 12 }}
						>
							Friendships Made
						</PrimaryText>
						<PrimaryText fontSize={36} fontWeight={800}>
							{companyData?.friendshipsCount ?? "N/A"}
						</PrimaryText>
					</DashboardItem>
				</Grid>
				{/* -----------------------  Dashboard third row  ends ----------------------- */}
			</Grid>
			<SubscriptionStats />
		</View>
	);
};
